import { requestAverageIntersections, requestPaiwiseIntersections } from '../../../../../../../../lib/esm/components';
import { handleServerResponse, TServerResponse } from '../../../../../../../../tools/API/handleServerResponse';
import { useWidgetCurrentOptions } from '../../../../../../../../tools/useWidgetCurrentOptions';
import generatePercentIntersectionsQueryData from '../tools/generateIntersectionsQueryData';
import responseAnalyzer from '../../../../../../../../tools/API/responseAnalyzer';
import { generalReducerValues } from '../../../../../../../../General.reducer';
import { ResponseStatus } from '../../../../../../../../tools/API/constants';
import { useDispatch, useSelector } from 'react-redux';
import usePrepareData from './usePrepareData';
import { useEffect } from 'react';
import {
    Leasing_TenantOverview_IntersectionsWithTenants_Widget_Reducer_Values,
    storeRawPercentAverageIntersections,
    storeRawPaiwiseIntersections,
    storeIntersectionsDataById,
    toggleLoading,
    toggleError,
} from '../reducer';
import { Leasing_TenantOverview_Module_Reducer_Values } from '../../../reducer';

/** Кастомный хук получения данных */
export const useGetRawData = () => {
    const { moduleName } = useSelector(Leasing_TenantOverview_Module_Reducer_Values);
    const { extendedReportingObjectsById, dataRefetchObject } = useSelector(
        Leasing_TenantOverview_IntersectionsWithTenants_Widget_Reducer_Values,
    );
    const localCurrentOptions = useWidgetCurrentOptions(moduleName);
    const { token } = useSelector(generalReducerValues);
    const dispatch = useDispatch();
    usePrepareData();

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        if (
            extendedReportingObjectsById &&
            localCurrentOptions?.mainDateRanges &&
            localCurrentOptions?.mainPeriod &&
            token
        ) {
            const percentQueryData = generatePercentIntersectionsQueryData({
                extendedReportingObjectsById,
                token,
                mainPeriod: localCurrentOptions.mainPeriod,
                mainDateRanges: localCurrentOptions.mainDateRanges,
            }).map((element) => ({ ...element, signal }));

            const paiwiseQueryData = generatePercentIntersectionsQueryData({
                extendedReportingObjectsById,
                token,
                mainPeriod: localCurrentOptions.mainPeriod,
                mainDateRanges: localCurrentOptions.mainDateRanges,
            }).map((element) => ({ ...element, signal }));
            dispatch(toggleLoading(true));
            dispatch(toggleError(false));
            dispatch(storeIntersectionsDataById(null));

            dispatch(storeRawPercentAverageIntersections({ status: ResponseStatus.Loading, message: 'Loading...' }));
            requestAverageIntersections(percentQueryData).then((responses: TServerResponse) => {
                handleServerResponse({
                    responseAnalyzer: responseAnalyzer,
                    success: storeRawPercentAverageIntersections,
                    error: storeRawPercentAverageIntersections,
                    res: responses,
                    dispatch,
                });
            });

            dispatch(storeRawPaiwiseIntersections({ status: ResponseStatus.Loading, message: 'Loading...' }));
            requestPaiwiseIntersections(paiwiseQueryData).then((responses: TServerResponse) => {
                handleServerResponse({
                    responseAnalyzer: responseAnalyzer,
                    success: storeRawPaiwiseIntersections,
                    error: storeRawPaiwiseIntersections,
                    res: responses,
                    dispatch,
                });
            });
        }
        return () => controller.abort();
    }, [extendedReportingObjectsById, localCurrentOptions?.mainPeriod, token, dataRefetchObject]);
};
